<template>
  <form class="tools-partners-invite-modal">
    <snow-input
      v-model="form.name"
      id="name"
      label="Nome do colaborador"
      :errors="errors.name"
      :disabled="!!item && !!item.company"
    />

    <snow-input
      v-model="form.email"
      id="email"
      label="E-mail do colaborador"
      :errors="errors.email"
      :disabled="!!item && !!item.id"
    />
    <action-dispatcher
      action="partnersCenter/getProfiles"
      :parameters="{ limit: 999 }"
    >
      <snow-select
        v-model="form.perfil_id"
        label="Perfil"
        id="form-perfil"
        :options="profiles"
      />
    </action-dispatcher>

    <snow-switch v-model="form.is_admin" label="Administrador" />
    <snow-switch
      v-model="form.receive_notifications"
      label="Receber notificações"
    />

    <h6 class="text-dark-40">
      As notificações são referentes a e-mail, SMS e aplicativo mobile.
    </h6>
    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        text="Salvar"
        class="order-lg-1"
        @click="submit"
        :loading="loading"
        :disabled="!isValid"
      />
      <snow-button
        size="lg"
        text="Cancelar"
        variant="gray"
        @click="$emit('close')"
      />
    </div>
  </form>
</template>

<script>
import { formFields, updateArrayItem } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    item: Object
  },
  data() {
    return {
      ...formFields(
        ["email", "name", "perfil_id", "is_admin", "receive_notifications"],
        {
          is_admin: false,
          receive_notifications: false,
          ...(this.item || {})
        }
      )
    };
  },
  computed: {
    ...mapState("partnersCenter", ["profiles", "partners", "invitesSent"]),
    isValid() {
      return this.form.email && this.form.name && this.form.perfil_id;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      let action = this.postInvite;

      const data = (({
        email,
        name,
        perfil_id,
        is_admin,
        receive_notifications
      }) => ({
        email,
        name,
        perfil_id,
        is_admin,
        receive_notifications
      }))(this.form);

      if (this.item) {
        data.id = this.item.id;
        action = this.item.company ? this.updatePartner : this.putInvite;
      }
      try {
        await action(data);
      } catch (e) {
        this.errors = e.response.data;
      } finally {
        this.loading = false;
      }
    },
    async postInvite(data) {
      await this.$store.dispatch("partnersCenter/postInvite", data);
      this.$message.success("Convite enviado");
      this.$emit("close");
      this.$emit("reload");
    },
    async putInvite(data) {
      const response = await this.$store.dispatch(
        "partnersCenter/putInvite",
        data
      );
      this.$store.commit(
        "partnersCenter/setInvitesSent",
        updateArrayItem(this.invitesSent, response)
      );
      this.$message.success("Convite atualizado");
      this.$emit("close");
    },
    async updatePartner(data) {
      const response = await this.$store.dispatch(
        "partnersCenter/putPartner",
        data
      );
      this.$store.commit(
        "partnersCenter/setPartners",
        updateArrayItem(this.partners, response)
      );
      this.$message.success("Colaborador atualizado");
      this.$emit("close");
    }
  }
};
</script>
<style>
.tools-partners-invite-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
